import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loginState, setLoginState] = useState(false);
  const [error, setError] = useState(null);

  const login = async (email, password) => {
    const res = await axios
      .post(`${process.env.REACT_APP_LOCAL_PRODUCTOS}login`, {
        email: email,
        password: password,
      })
      .then((res) => {
        if (res.data.token && res.data.status) {
          setLoginState(res.data.status);
          setToken(res.data.token);
          setUser("Administrador");
          localStorage.setItem(
            "user",
            JSON.stringify({ name: user, token: token }),
          );
          if (token) {
            setError(false);
          } else {
            setError(true);
          }
        }
      })

      .catch((error) => {
        console.error(error);
      });
  };

  const logout = async (token) => {
    const res = await axios
      .get(`${process.env.REACT_APP_LOCAL_PRODUCTOS}logout`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        console.log(res.data);
        setLoginState(false);
        setUser(null);
        setToken(null);
        localStorage.removeItem("user");
        setError(null);
      })
      .catch((e) => {
        console.error(`Error al cerrar sesión, descripción: ${e}`);
      });
  };

  return (
    <AuthContext.Provider
      value={{ user, login, logout, token, loginState, error, setError }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
